import { apiEndpoint } from '../../config/app';
import createRestApiClient from '../utils/createRestApiClient';

export default () =>{
    const client = createRestApiClient().withConfig({ baseURL: apiEndpoint });
    return {
        getLeads: (websiteId) => client.request({
            method: 'GET',
            url: `/lead`
        }),
        createLead: (lead) => client.request({
            method: 'POST',
            url: `/lead/${lead.id}`,
            data: lead
        }),
        createReferral: (referral) => client.request({
            method: 'POST',
            url: '/referral',
            data: referral
        }),
        deleteLead: (id)=> client.request({
            method: 'DELETE',
            url: `/lead/${id}`
        }),
        getReferrals: (id)=> client.request({
            method: 'GET',
            url: `/referral/${id}`
        }),
        share: (id) => client.request({
            method: 'GET',
            url: `/share/${id}`
        }),
        click: (id) => client.request({
            method: 'GET',
            url: `/click/${id}`
        }),
        visit: (id) => client.request({
            method: 'GET',
            url: `/visit/${id}`
        }),
        stats: (filter) => client.request({
            method: 'POST',
            url: '/leads/public',
            data: filter
        })
    };
};


// WEBPACK FOOTER //
// app/services/leads.js